export default "__VITE_ASSET__BKVaUvfP__"